import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, List, ListItem, MenuItem, Paper, TextField, Typography } from '@material-ui/core';
import { createStyles, StyledComponentProps, Theme, withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { EntityImage } from '../../comps/EntityImage';
import { ItemDetail } from '../../comps/ItemDetail';
import { OcButton } from '../../comps/OcButton';
import { OcDataview } from '../../comps/OcDataview';
import OcDatetimePicker, { IDeliveryDayStatus } from '../../comps/OcDateTimePicker';
import { IEntity } from '../../main/entities';
import { transl } from '../../main/transl';
import { mg } from '../../mg/mg';
import { commSvc, IOcResponse } from '../../services/CommSvc';
import { toasterSvc } from '../../services/ToasterSvc';
import { DataviewStore } from '../../stores/DataviewStore';
import { getOmnistore } from '../../stores/Omnistore';
import { pendingActionsStore } from '../../stores/PendingActionsStore';
import { adOrderingStore, IAdOrderingItem } from '../ads/AdsOrderingStore';
import { IMySupplier } from './MiniCart';
import { OrderOptionsStore } from './OrderOptionsStore';
import { orderOptionsStoreManager } from './OrderOptionsStoreManager';
import { orderResultDialogStore } from './OrderResultDialogStore';

const styles = (theme: Theme) => createStyles({
	cart: {
		margin: theme.spacing(2, 0),
	},
	supplierLogo: {
		height: theme.spacing(6),
		marginLeft: theme.spacing(1),
	},
	info: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-end',
	},
	priceText: {
		color: '#CE240F',
	},
	bottom: {
		marginBottom: theme.spacing(1),
		padding: theme.spacing(0.5),
	},
	warnings: {
	},
	warning: {
	},
	errorItem: {
		display: 'list-item',
		listStyle: 'disc inside',
	},
	choices: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'stretch',
	},
	choicePlaceholder: {
		flex: '0 1 220px',
		marginTop: theme.spacing(1),
		padding: theme.spacing(0, 0.5),
		textDecoration: ' line-through',
	},
	choiceBox: {
		flex: '0 1 220px',
		marginTop: theme.spacing(1),
		padding: theme.spacing(0, 0.5),
	},
	orderButton: {
		justifySelf: 'flex-end',
		height: theme.spacing(6.5),
	},
	enabledOrderButton: {
		backgroundColor: '#14B884',
		'&:hover': {
			backgroundColor: '#14D884',
		}
	},
	disabledOrderButton: {
		backgroundColor: '#D5D5D5',
		color: '#999999',
		'&:hover': {
			color: '#AAAAAA',
		}
	},
	summary: {
		display: 'flex',
		margin: theme.spacing(0),
		padding: theme.spacing(0),
		width: '100%',
	},
});

const MyExpansionPanel = withStyles((theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
	},
}))(ExpansionPanel);

const MyExpansionPanelSummary = withStyles((theme: Theme) => ({
	content: {
		justifyContent: 'space-between',
		margin: theme.spacing(0.5),
	},
}))(ExpansionPanelSummary);

const MyExpansionPanelDetails = withStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: 500,
		padding: 0,
	},
})(ExpansionPanelDetails);

const ss = {
	itemsPaper: {
		height: 'none',
	},
};

interface ICheckoutCartProps {
	template: IEntity
	supplier: IMySupplier
	repo: any // TODO
	adOrderingItems: Array<IAdOrderingItem>
	isSelected: boolean
	onSelect: any //TODO
	dataviewStore: Instance<typeof DataviewStore>
}

interface IDeliveryDay {
	date: string
	status: IDeliveryDayStatus
}

@observer class _CheckoutCart extends React.Component<ICheckoutCartProps & StyledComponentProps> {
	@computed get multirepo() {
		return getOmnistore().multirepo;
	}

	@computed get reoctoStore() {
		return getOmnistore().reoctoStore;
	}

	@observable _deliveryDaysMap: Map<string, IDeliveryDayStatus> = new Map()

	@action _setDeliveryDays(deliveryDays: Array<IDeliveryDay>) {
		this._deliveryDaysMap = new Map(deliveryDays.map(o => [o.date, o.status]));
	}

	_orderOptionsStore = (undefined as any) as Instance<typeof OrderOptionsStore>

	constructor(props) {
		super(props);
		{
			const x = orderOptionsStoreManager.get(this.props.template.id);
			this._orderOptionsStore = x;
			x.applySupplier(this.props.supplier);
		}
		this.multirepo.accessTemplateRepo.fetch();
		const {supplier} = this.props;
		if (supplier.kind === 'ONLINE') {
			commSvc.doGet('GetDeliveryDays', {_: this.props.template.id})
				.then(toasterSvc.failure)
				.then(commSvc.requireOutputList)
				.then(r => this._setDeliveryDays(r.outputList as Array<IDeliveryDay>));
		}
	}

	get _actionName() {
		return 'CreateOrder:' + this.props.template.id;
	}

	@computed get _isAllowedToOrder() {
		const {template} = this.props;
		for (let o of this.multirepo.accessTemplateRepo.allAsList) {
			if (o.capability !== 'OWNER' && o.capability != 'ORDER') continue;
			if (o.email !== getOmnistore().authStore.email) continue;
			if (o.templateId !== template.id) continue;
			return true;
		}
		return false;
	}

	@computed get _errors() {
		const {supplier, adOrderingItems} = this.props;
		const options = this._orderOptionsStore as Instance<typeof OrderOptionsStore>;
		const invalidForm = false
			|| options.isPickup && !options.pickupLocation
			|| options.paymentMethods.length!==1 && !options.paymentMethod;
		return [
			!this._isAllowedToOrder ? 'notAllowed' : '',
			options.tooLate ? 'tooLate' : '',
			supplier.kind!=='ONLINE' && !supplier.email.match(/^[^@]+@[^.]+\..+$/) ? 'noSupplierEmail' : '',
			options.message.length>255 ? 'messageTooLong' : '',
			!supplier.nPricedItems && !supplier.nUnpricedItems && !adOrderingItems.length ? 'emptyCart' : '',
			pendingActionsStore.isPending(this._actionName) ? 'running' : '',
			this.reoctoStore.isOffline ? 'isOffline' : '',
			invalidForm ? 'invalidForm' : '',
		].filter(x => x);
	}

	@computed get isNotScheduledDay() {
		const date = this._orderOptionsStore.date;
		const map = this._deliveryDaysMap;
		return date && map.size && map.get(date) != 'AVAILABLE';
	}

	@computed get _warnings() {
		const {supplier} = this.props;
		const result = [
			supplier.orderHint,
			this.isNotScheduledDay ? transl('order.isNotScheduledDay') : '',
		];
		return result.filter(x => x);
	}

	@computed get _selectedEntity() : IEntity | undefined {
		const {dataviewStore} = this.props;
		const id = dataviewStore.selectedEntityId;
		if (!id) return undefined;
		for (let e of this.props.repo.allAsList) {
			if (e.id === id) return e;
		}
		return undefined;
	}

	@computed private get _reducedErrors(): Array<string> {
		const errors: Array<string> = this._errors;
		if (~errors.indexOf('notAllowed')) return ['notAllowed'];
		if (~errors.indexOf('emptyCart')) return ['emptyCart'];
		return errors;
	}

	@computed private get _renderErrors() : JSX.Element {
		const classes = this.props.classes || {};
		return <List>{this._reducedErrors.map(e => <ListItem key={e} className={classes.errorItem}>{transl('order.' + e)}</ListItem>)}</List>;
	}

	@computed private get _isLeaving() : boolean {
		const errors: Array<string> = this._errors;
		if (~errors.indexOf('notAllowed')) return true;
		if (~errors.indexOf('emptyCart')) return true;
		return false;
	}

	@computed private get _leavingAction() : (() => void) | undefined {
		return this._isLeaving ? () => getOmnistore().locationStore.setPage('LTemplates') : undefined;
	}

	@action _doOrder = event => {
		event.stopPropagation();
		if (this._errors.length) {
			orderResultDialogStore.showFailure(this._errors);
			return;
		}
		const prototype = this._orderOptionsStore.toPrototype;
		const templateItems = this.props.repo.allAsList.filter(e => e.amountToOrder>0).map(e => ({id: e.id, amountToOrder: e.amountToOrder}));
		const supplierItems = this.props.adOrderingItems.map(i => ({id: i.supplierItemId, amountToOrder: i.amountToOrder}));
		const coupon = this._orderOptionsStore.coupon;
		const order = {prototype, templateItems, supplierItems, coupon, serverSends: true};
		pendingActionsStore.setPending(this._actionName);
		return commSvc.doPost('CreateOrder', order)
			.then((r: IOcResponse) => {
				const outputList = r.outputList;
				if (!outputList) return r;
				this._orderOptionsStore.setMessage('');
				this._orderOptionsStore.setCoupon('');
				const fetches = outputList.map(o => getOmnistore().multirepo.templateItemRepo(o.templateId).fetchDirect());
				orderResultDialogStore.showSuccess(outputList, this.props.supplier);
				this.props.adOrderingItems.forEach(i => adOrderingStore.remove(i));
				return Promise.all(fetches).then(() => r);
			})
			.then(toasterSvc.failure)
			.finally(() => pendingActionsStore.clearPending(this._actionName))
			.finally(() => this.multirepo.orderRepo.fetch('DIRECT'));
	}

	_renderTop() {
		const classes = this.props.classes || {};
		const {supplier, repo, isSelected, onSelect, dataviewStore} = this.props;

		return <MyExpansionPanel expanded={isSelected} onChange={onSelect}>
			<MyExpansionPanelSummary expandIcon={<ExpandMoreIcon/>} className={classes.summary}>
				{
					supplier.imageLink
						?
						<EntityImage entity={supplier} className={classes.supplierLogo}/>
						:
						<Typography variant="h6" className={classes.supplierLogo}>{supplier.name}</Typography>
				}
				<Typography color="primary" className={classes.info} component="div">{
					!supplier.nPricedItems && !supplier.nUnpricedItems
						?
						<div className={classes.items}>{transl('minicart.noItems')}</div>
						:
						!supplier.nPricedItems
							?
							<div className={classes.items}>{transl('minicart.items', supplier.nUnpricedItems)}</div>
							:
							!supplier.nUnpricedItems
								?
								<>
									<div className={classes.items}>{transl('minicart.items', supplier.nPricedItems)}</div>
									<div className={classes.priceText}>{supplier.priceText}</div>
								</>
								:
								<>
									<div className={classes.items}>{transl('minicart.items', supplier.nPricedItems)}</div>
									<div className={classes.priceText}>{supplier.priceText}</div>
									<div className={classes.items}>{transl('minicart.unpricedItems', supplier.nUnpricedItems)}</div>
								</>
				}</Typography>
			</MyExpansionPanelSummary>
			<MyExpansionPanelDetails>{
				!isSelected ? <span/> :
					<OcDataview repo={repo} state={dataviewStore} paperStyle={ss.itemsPaper}/>
			}</MyExpansionPanelDetails>
		</MyExpansionPanel>;
	}

	_renderBottom() {
		const classes = this.props.classes || {};
		const options = this._orderOptionsStore;
		const classes2 = {orderButton: mg.clsn(classes.choiceBox, classes.orderButton)};
		return <div className={classes.bottom}>
			<div className={classes.warnings}>{
				this._warnings.map(w => <Typography key={w} color="secondary" className={classes.warning}>{w}</Typography>)
			}</div>
			<div className={classes.choices}>
				{
					!options.canPickup ? null :
						<TextField variant="outlined" color="secondary" className={classes.choiceBox} select required
							label={transl('order.deliveryKind')}
							value={options.isPickup ? 1 : 0}
							onChange={e => options.setIsPickup(!!e.target.value)}
							SelectProps={{MenuProps: {className: classes.menu}}}
							InputLabelProps={{shrink: true}}
						>
							<MenuItem value={0} key={0}>{transl('order.delivery')}</MenuItem>
							<MenuItem value={1} key={1}>{transl('order.pickup')}</MenuItem>
						</TextField>
				}
				{
					!options.isPickup ? !options.canPickup ? null :
						<TextField variant="outlined" className={classes.choicePlaceholder} label={'·'} disabled={true}/>
						:
						<TextField variant="outlined" color="secondary" className={classes.choiceBox} select required
							label={transl('order.pickupLocation')}
							value={options.pickupLocation}
							error={!options.pickupLocation}
							onChange={e => options.setPickupLocation(e.target.value)}
							SelectProps={{MenuProps: {className: classes.menu}}}
							InputLabelProps={{shrink: true, disabled: true}}
						>
							{options.pickupLocationsList.map(x => <MenuItem value={x} key={x}>{x}</MenuItem>)}
						</TextField>
				}
				{
					options.paymentMethods.length===1 ? null :
						<TextField variant="outlined" className={classes.choiceBox} select required
							label={transl('order.paymentMethod')}
							value={options.paymentMethod}
							error={!options.paymentMethod}
							onChange={e => options.setPaymentMethod(e.target.value)}
							SelectProps={{MenuProps: {className: classes.menu}}}
							InputLabelProps={{shrink: true}}
						>
							{options.paymentMethods.map(x => <MenuItem value={x} key={x}>{transl('Order_PaymentMethod.' + x)}</MenuItem>)}
						</TextField>
				}
				{
					<OcDatetimePicker
						inputVariant="outlined"
						type={options.datetimePickerType}
						value={options.datetime}
						onChange={value => options.setDatetime(value)}
						label={transl((options.isPickup ? 'order.pickupDate' : 'order.deliveryDate')
								+ (options.datetimePickerType === 'DATETIME' ? 'time' : ''))}
						error={false}
						required={true}
						dayStatusMap={this._deliveryDaysMap}
						classes={classes}
					/>
				}
				{
					!options.canOrderMessage ? null :
						<TextField variant="outlined" className={classes.choiceBox}
							label={transl('order.message')}
							value={options.message}
							onChange={e => options.setMessage(e.target.value)}
							InputLabelProps={{shrink: true}}
						/>
				}
				{
					!options.orderReferenceLength ? null :
						<TextField variant="outlined" className={classes.choiceBox}
							label={transl('order.orderReference')}
							value={options.orderReference}
							error={options.orderReference.length > options.orderReferenceLength}
							onChange={e => options.setOrderReference(e.target.value)}
							InputLabelProps={{shrink: true}}
						/>
				}
				{
					!options.hasCoupon ? null :
						<TextField variant="outlined" className={classes.choiceBox}
							label={transl('order.coupon')}
							value={options.coupon}
							onChange={e => options.setCoupon(e.target.value)}
							InputLabelProps={{shrink: true}}
						/>
				}
				<OcButton size="large"
					disabled={!!this._errors.length}
					disabledText={this._renderErrors}
					dialogCloseText={this._isLeaving ? transl('order.leavingForTemplates') : undefined}
					dialogCloseAction={this._leavingAction}
					color="primary"
					variant="contained"
					className={classes2.orderButton}
					onClick={this._doOrder}>
					<Typography variant="h5">{transl('doOrder')}</Typography>
				</OcButton>
			</div>
		</div>;
	}

	render() {
		const classes = this.props.classes || {};
		const {dataviewStore, template} = this.props;
		const templateItemRepo = getOmnistore().entityManagerStore.get('TemplateItem', template.id);
		const e: any = this._selectedEntity; //TODO
		return <Paper className={classes.cart}>
			{this._renderTop()}
			{this._renderBottom()}
			<ItemDetail
				state={dataviewStore}
				entity={e} repo={templateItemRepo}
				categories={this.multirepo.currentCategories}
				fetchCurrentCategories={this.multirepo.fetchCurrentCategories}/>
		</Paper>;
	}
}

export const CheckoutCart = withStyles(styles)(_CheckoutCart);
